/**
 * Multi-language translations
 * Supports: English, Persian, Pashto, Turkish, Arabic
 */
export const translations = {
  en: {
    chatbotName: 'AFGCoin Support',
    welcome: 'Welcome! Please select your preferred language.',
    languageSet: 'Language has been set. How can I help you today?',
    loading: 'Loading...',
    send: 'Send',
    error: 'An error occurred. Please try again.',
    requestHuman: 'Talk to Human Agent',
    humanWaiting: 'A human support agent will assist you shortly. Please wait.',
    continueWithChatbot: 'Continue with chatbot',
    
    identification: {
      email: 'Email',
      emailPlaceholder: 'Enter your email',
      firstName: 'First Name',
      firstNamePlaceholder: 'Enter your first name',
      lastName: 'Last Name',
      lastNamePlaceholder: 'Enter your last name',
      submit: 'Continue'
    },
    
    languageSelection: {
      prompt: 'Please select your preferred language:'
    },
    
    faq: {
      prompt: 'How can I help you? Please select an option:'
    },
    
    aiInput: {
      placeholder: 'Type your message...'
    },
    
    errors: {
      emailRequired: 'Email is required',
      emailInvalid: 'Please enter a valid email address',
      firstNameRequired: 'First name is required',
      lastNameRequired: 'Last name is required',
      connectionFailed: 'Connection failed. Check your internet and that the app has the correct API address.'
    }
  },
  
  fa: {
    chatbotName: 'پشتیبانی AFGCoin',
    welcome: 'خوش آمدید! لطفاً زبان مورد نظر خود را انتخاب کنید.',
    languageSet: 'زبان تنظیم شد. امروز چگونه می‌توانم به شما کمک کنم؟',
    loading: 'در حال بارگذاری...',
    send: 'ارسال',
    error: 'خطایی رخ داد. لطفاً دوباره تلاش کنید.',
    requestHuman: 'صحبت با نماینده انسانی',
    humanWaiting: 'یک نماینده پشتیبانی انسانی به زودی به شما کمک خواهد کرد. لطفاً صبر کنید.',
    continueWithChatbot: 'ادامه با چت‌بات',
    
    identification: {
      email: 'ایمیل',
      emailPlaceholder: 'ایمیل خود را وارد کنید',
      firstName: 'نام',
      firstNamePlaceholder: 'نام خود را وارد کنید',
      lastName: 'نام خانوادگی',
      lastNamePlaceholder: 'نام خانوادگی خود را وارد کنید',
      submit: 'ادامه'
    },
    
    languageSelection: {
      prompt: 'لطفاً زبان مورد نظر خود را انتخاب کنید:'
    },
    
    faq: {
      prompt: 'چگونه می‌توانم به شما کمک کنم؟ لطفاً یک گزینه انتخاب کنید:'
    },
    
    aiInput: {
      placeholder: 'پیام خود را تایپ کنید...'
    },
    
    errors: {
      emailRequired: 'ایمیل الزامی است',
      emailInvalid: 'لطفاً یک آدرس ایمیل معتبر وارد کنید',
      firstNameRequired: 'نام الزامی است',
      lastNameRequired: 'نام خانوادگی الزامی است',
      connectionFailed: 'اتصال برقرار نشد. اینترنت و آدرس API برنامه را بررسی کنید.'
    }
  },
  
  ps: {
    chatbotName: 'د AFGCoin ملاتړ',
    welcome: 'ښه راغلاست! مهرباني وکړئ خپل غوره ژبه وټاکئ.',
    languageSet: 'ژبه تنظیم شوه. نن زه څنګه کولی شم تاسو سره مرسته وکړم؟',
    loading: 'پورته کېدل...',
    send: 'لیږل',
    error: 'یوه تېروتنه رامنځته شوه. مهرباني وکړئ بیا هڅه وکړئ.',
    requestHuman: 'د انسانی استازي سره خبرې',
    humanWaiting: 'د انسانی ملاتړ استازی به ژر تاسو سره مرسته وکړي. مهرباني وکړئ انتظار وکړئ.',
    continueWithChatbot: 'له چت‌بات سره دوام ورکړئ',
    
    identification: {
      email: 'بریښنالیک',
      emailPlaceholder: 'خپل بریښنالیک داخل کړئ',
      firstName: 'لومړی نوم',
      firstNamePlaceholder: 'خپل لومړی نوم داخل کړئ',
      lastName: 'وروستی نوم',
      lastNamePlaceholder: 'خپل وروستی نوم داخل کړئ',
      submit: 'دوام'
    },
    
    languageSelection: {
      prompt: 'مهرباني وکړئ خپل غوره ژبه وټاکئ:'
    },
    
    faq: {
      prompt: 'زه څنګه کولی شم تاسو سره مرسته وکړم؟ مهرباني وکړئ یو اختیار وټاکئ:'
    },
    
    aiInput: {
      placeholder: 'خپل پیغام ولیکئ...'
    },
    
    errors: {
      emailRequired: 'بریښنالیک اړین دی',
      emailInvalid: 'مهرباني وکړئ د بریښنالیک معتبر پته داخل کړئ',
      firstNameRequired: 'لومړی نوم اړین دی',
      lastNameRequired: 'وروستی نوم اړین دی',
      connectionFailed: 'اړیکه ونشوه. انټرنېټ او د اپ API پته وګورئ.'
    }
  },
  
  tr: {
    chatbotName: 'AFGCoin Destek',
    welcome: 'Hoş geldiniz! Lütfen tercih ettiğiniz dili seçin.',
    languageSet: 'Dil ayarlandı. Bugün size nasıl yardımcı olabilirim?',
    loading: 'Yükleniyor...',
    send: 'Gönder',
    error: 'Bir hata oluştu. Lütfen tekrar deneyin.',
    requestHuman: 'İnsan Temsilcisiyle Konuş',
    humanWaiting: 'Bir insan destek temsilcisi kısa süre içinde size yardımcı olacaktır. Lütfen bekleyin.',
    continueWithChatbot: 'Chatbot ile devam et',
    
    identification: {
      email: 'E-posta',
      emailPlaceholder: 'E-postanızı girin',
      firstName: 'Ad',
      firstNamePlaceholder: 'Adınızı girin',
      lastName: 'Soyad',
      lastNamePlaceholder: 'Soyadınızı girin',
      submit: 'Devam Et'
    },
    
    languageSelection: {
      prompt: 'Lütfen tercih ettiğiniz dili seçin:'
    },
    
    faq: {
      prompt: 'Size nasıl yardımcı olabilirim? Lütfen bir seçenek seçin:'
    },
    
    aiInput: {
      placeholder: 'Mesajınızı yazın...'
    },
    
    errors: {
      emailRequired: 'E-posta gereklidir',
      emailInvalid: 'Lütfen geçerli bir e-posta adresi girin',
      firstNameRequired: 'Ad gereklidir',
      lastNameRequired: 'Soyad gereklidir',
      connectionFailed: 'Bağlantı başarısız. İnterneti ve uygulama API adresini kontrol edin.'
    }
  },
  
  ar: {
    chatbotName: 'دعم AFGCoin',
    welcome: 'مرحباً! يرجى اختيار لغتك المفضلة.',
    languageSet: 'تم تعيين اللغة. كيف يمكنني مساعدتك اليوم؟',
    loading: 'جاري التحميل...',
    send: 'إرسال',
    error: 'حدث خطأ. يرجى المحاولة مرة أخرى.',
    requestHuman: 'التحدث مع ممثل بشري',
    humanWaiting: 'سيساعدك ممثل دعم بشري قريبًا. يرجى الانتظار.',
    continueWithChatbot: 'متابعة مع المساعد',
    
    identification: {
      email: 'البريد الإلكتروني',
      emailPlaceholder: 'أدخل بريدك الإلكتروني',
      firstName: 'الاسم الأول',
      firstNamePlaceholder: 'أدخل اسمك الأول',
      lastName: 'اسم العائلة',
      lastNamePlaceholder: 'أدخل اسم عائلتك',
      submit: 'متابعة'
    },
    
    languageSelection: {
      prompt: 'يرجى اختيار لغتك المفضلة:'
    },
    
    faq: {
      prompt: 'كيف يمكنني مساعدتك؟ يرجى اختيار خيار:'
    },
    
    aiInput: {
      placeholder: 'اكتب رسالتك...'
    },
    
    errors: {
      emailRequired: 'البريد الإلكتروني مطلوب',
      emailInvalid: 'يرجى إدخال عنوان بريد إلكتروني صالح',
      firstNameRequired: 'الاسم الأول مطلوب',
      lastNameRequired: 'اسم العائلة مطلوب',
      connectionFailed: 'فشل الاتصال. تحقق من الإنترنت وعنوان API للتطبيق.'
    }
  }
};

